import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ReactQueryKey } from "../../../../../../../types";

import { getBookingCategories } from "../../../../../../../api/services";

import { FormAutocomplete } from "../../../../../../../components/fields";
import useFormTenantsDealers from "../form-tenants-dealers-hook/useFormTenantsDealers";

/**
 * Filter Form component of category
 */
const FormAutocompleteCategory = () => {

    const { t } = useTranslation('booking');
    const { tenants, dealers } = useFormTenantsDealers();

    const categoriesQuery = useQuery({
        queryKey: [ReactQueryKey.BookingCategories, { tenants, dealers }],
        queryFn: () => getBookingCategories({ tenants, dealers }),
    });

    return (
        <FormAutocomplete<any>
            name="categories"
            label={t('label.categories')}
            options={categoriesQuery.data || []}
            loading={categoriesQuery.isLoading}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            multiple
        />
    );

}

export default FormAutocompleteCategory;
